<script lang="ts">
	import type { Snippet } from 'svelte';

	// activeClass / hoverClass kept as props for API parity with Skel 2 AppRail consumers,
	// but applied per-anchor via SideRailAnchor — NOT on the parent <aside>. A hover:*
	// utility on the parent fires when ANY child is hovered (CSS hover bubbles up the tree),
	// which lit up every anchor at once.
	interface Props {
		activeClass?: string;
		hoverClass?: string;
		lead?: Snippet;
		trail?: Snippet;
	}

	// activeClass / hoverClass are part of the legacy AppRail surface — kept for caller
	// API parity even though SideRail itself does not apply them (children do, via
	// SideRailAnchor). ESLint flags them unused; intentional.

	let {
		activeClass: _ac = 'bg-surface-50-800 text-primary-500',
		hoverClass: _hc = '',
		lead,
		trail
	}: Props = $props();
</script>

<aside class="flex h-full flex-col font-manrope text-md font-semibold">
	<div class="flex-shrink-0">
		{@render lead?.()}
	</div>
	<div class="flex-1"></div>
	<div class="flex-shrink-0">
		{@render trail?.()}
	</div>
</aside>
